import React, { type ReactNode, useMemo } from 'react';

import {
	type AIEventsInstrumentationConfig,
	AIEventsInstrumentationContext,
	type AIEventsInstrumentationContextType,
} from '../context';
import { defaultAIEventsInstrumentationConfigValues } from '../context/model';
import { useAIInstrumentationSetup } from '../hooks';

const validateAIEventsConfig = (config: AIEventsInstrumentationConfig) => {
	if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) {
		// eslint-disable-next-line no-console
		console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
	}
};

type Props = {
	children: ReactNode;
	config: AIEventsInstrumentationConfig;
};

export const AIEventsInstrumentationProvider = ({ children, config }: Props): React.JSX.Element => {
	const {
		refreshSingleInstrumentationID,
		getSingleInstrumentationID,
		setAISessionState,
		getAISessionState,
	} = useAIInstrumentationSetup(config.singleInstrumentationID);

	const contextValue = useMemo<AIEventsInstrumentationContextType>(() => {
		validateAIEventsConfig(config);
		return {
			config: {
				...defaultAIEventsInstrumentationConfigValues,
				...config,
				product: config.product.toLowerCase(),
			},
			refreshSingleInstrumentationID,
			getSingleInstrumentationID,
			setAISessionState,
			getAISessionState,
		};
	}, [
		config,
		refreshSingleInstrumentationID,
		getSingleInstrumentationID,
		setAISessionState,
		getAISessionState,
	]);

	return (
		<AIEventsInstrumentationContext.Provider value={contextValue}>
			{children}
		</AIEventsInstrumentationContext.Provider>
	);
};
